import { Box } from "@mui/material";
import { ReactComponent as RouletteWinnerBackground } from "assets/roulette-winner-border.svg";
import { ReactComponent as RouletteWinnerBackgroundTsl } from "assets/roulette-winner-border-tsl.svg";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { withBamLayoutSelector } from "@redux/user/selectors";

interface Props {
	children: React.ReactNode;
	display: string;
}

export const RouletteWinnerBox = ({ children, display }: Props) => {
	const backgroundImageRef = useRef<SVGSVGElement | null>(null);
	const withBamLayout = useSelector(withBamLayoutSelector);

	const style: React.CSSProperties = {
		position: "absolute",
		zIndex: 1,
		width: "100%",
		height: "100%",
		top: 0,
		left: 0,
		overflow: "hidden",
	};

	return (
		<Box
			width={"70%"}
			height={"70%"}
			display={display}
			sx={{
				position: "relative",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			{withBamLayout ? (
				<RouletteWinnerBackground ref={backgroundImageRef} style={style} />
			) : (
				<RouletteWinnerBackgroundTsl ref={backgroundImageRef} style={style} />
			)}
			<Box
				width={"80%"}
				height={"70%"}
				display="flex"
				justifyContent="center"
				alignItems="center"
			>
				{children}
			</Box>
		</Box>
	);
};
